import { render, staticRenderFns } from "./RelayMobile.vue?vue&type=template&id=69ac5fdd&"
import script from "./RelayMobile.vue?vue&type=script&lang=ts&"
export * from "./RelayMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports